import React from 'react';
import {
  Box, Container, Grid, Skeleton,
} from '@mui/material';

const LocationsSkeletonV2 = () => (
  <Box mt={5}>
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <Grid item md={2} sm={10}>
          <Skeleton variant="text" width="100%" height={80} />
        </Grid>
        <Grid item md={2} sm={2}>
          <Skeleton variant="text" width="100%" height={80} />
        </Grid>
        {[...Array(3).keys()].map((item) => (
          <Grid key={item} item md={2} className="showTabletAndDesktop">
            <Skeleton variant="text" width="100%" height={80} />
          </Grid>
        ))}
      </Grid>
      <Box my={6}>
        <Skeleton
          sx={{ marginBottom: 8 }}
          variant="text"
          width="50%"
          height={80}
        />
        <Grid container spacing={2}>
          {[...Array(10).keys()].map((item) => (
            <Grid item key={item} lg={4} md={6} sm={12}>
              {[...Array(10).keys()].map((locationItem) => (
                <Skeleton
                  key={locationItem}
                  sx={{
                    marginBottom: 4,
                    width: { md: '60%', sm: '100%' },
                  }}
                  variant="rectangular"
                  height={32}
                />
              ))}
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  </Box>
);

export { LocationsSkeletonV2 };
